
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/darkweb",
      function () {
        return require("private-next-pages/archive/darkweb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/darkweb"])
      });
    }
  